import {DemoRegistrationFormValues} from './types';

export const isValidWebsite = (value: string) => {
  const normalizedValue = value.trim();

  if (!normalizedValue) return true;

  try {
    const url = new URL(normalizedValue.startsWith('http') ? normalizedValue : `https://${normalizedValue}`);

    return Boolean(url.hostname && url.hostname.includes('.'));
  } catch {
    return false;
  }
};

export const buildCreateForDemoPayload = (values: DemoRegistrationFormValues) => ({
  fullCompanyName: values.fullCompanyName.trim(),
  inn: values.inn.trim(),
  phone: values.phone.trim(),
  email: values.email.trim(),
  website: values.website.trim() || undefined,
});
